import React, { use, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/LandingPage.css';
import ContentBox from './new/ContentBox';
import Icon from '@mui/material/Icon';
import { ArrowForward } from '@mui/icons-material';
import FloatingWidgets from './FloatingWidgets';

function LandingPage() {
    const navigate = useNavigate();

    // useEffect(() => {
    //     console.log('here');    
    //     document.body.style.background = "repeating-radial-gradient(circle at 50% 50%,#ffffff 0%,#0099ff 50%,#ffffff 100%,#0099ff 150%,#ffffff 200%,#0099ff 250%";    
    //     document.body.style.backgroundPosition = "center";    
    //     document.body.style.animation = "backgroundPulse 15s ease-in-out infinite";
    // }, []);
    

    return (
        <ContentBox>
            <div className="intro-main">
                <h1 style={{margin: 0}}>Welcome to Meta Invoice</h1>
                <p style={{margin: 0}}>
                    Instagram made <b>$69 billion</b> from us last year.  
                    We made nothing.
                </p>
                    Our attention is an asset.<br/>
                    Our imagination is their profit.<br/>
                    We create the value.<br/>
                <p>    
                    <b>It's time to send the bill.</b>
                </p>
                <button style={{width: '100%'}} onClick={() => navigate('/form/intro')}>Generate Invoice</button>
                <a href='https://www.youtube.com/watch?v=Jo8jmv4l2IE' target='_blank' className='link'>Ease Your Mind<ArrowForward></ArrowForward></a>
            </div>
        </ContentBox>
    );
}

export default LandingPage;
